<template>

	<Percentage />

	<div class='story' >
		
		<div class="blok beeldblok">
			<video
				v-if="windowWidth > 1000" 
				class="knd-intro-video"
				autoplay 
				playsinline 
				loop 
				muted
				:src='require("@/assets/video/zeddam_intro_16x9_720p_v4.mp4")' >
				Uw browser ondersteunt het element <code>video</code> niet.
			</video>
			<video
				v-else-if="windowWidth > 500 && windowWidth <= 1000" 
				class="knd-intro-video"
				autoplay 
				playsinline 
				loop 
				muted
				:src='require("@/assets/video/zeddam_intro_4x5_720p_v1.mp4")' >
				Uw browser ondersteunt het element <code>video</code> niet.
			</video>
			<video
				v-else 
				class="knd-intro-video"
				autoplay 
				playsinline 
				loop 
				muted
				:src='require("@/assets/video/zeddam_intro_9x16_720p_v1.mp4")' >
				Uw browser ondersteunt het element <code>video</code> niet.
			</video>

			<div v-if="windowWidth <= 500" class="knd-mobiel-pijl">
				<Pijl kleur="F4FFE7" tekst="Scroll verder" />
			</div>
		</div>

		<div class="blok overgang"></div>

		<div class="blok blok-1">
			<div class="tekst">
				<Pijl v-if="windowWidth > 500" kleur="2C360A" tekst="Scroll verder" />

				<div class="kop">
					<h1 v-html="getContent(content.kop)"></h1>
				</div>

				<p class="intro" v-html="getContent(content.intro)"></p>

				<div class="knd-button" @click='goToId("tool")'>Geen tijd om te lezen? Ga direct naar de tool</div>
			</div>
				
			
			<div class="kader-geel-wrapper" id="carolien1">
				<div class="bol-rood bol-1"></div>
				<div class="kader-geel">
					<img :src='require("@/assets/img/carolien.png")' class="carolien" />
					<p v-html="getContent(content.blokken[0].tekst1)"></p>

					<video 
						playsinline 
						controls
						preload="metadata"
						class="video"
						:poster='require("@/assets/img/carolien_1.png")'>
						<source :src='require("@/assets/video/carolien_1.mp4#t=0.005")' type="video/mp4">
						Uw browser ondersteunt het element <code>video</code> niet.
					</video>
				</div>
			</div>

			<div class="bol-rood-wrapper bol-2">
				<div class="bol-rood"></div>
			</div>
			<div class="tekst">
				<div class="citaat" v-html="getContent(content.citaten[0].tekst)"></div>
				
				<p v-html="getContent(content.blokken[0].tekst2)"></p>
			</div>
		</div>

		<div class="blok beeldblok">
			<video 
				autoplay
				playsinline 
				muted
				:src='require("@/assets/video/chaptervideos/chaptervideo_1.mp4#t=0.001")' 
				class="video">
				Uw browser ondersteunt het element <code>video</code> niet.
			</video>
		</div>

		<div class="blok overgang"></div>

		<div class="blok blok-3" id="nederland">
			<div class="tekst">
				<h2 v-html="getContent(content.blokken[1].tussenkop1)"></h2>
				
				<p v-html="getContent(content.blokken[1].tekst1)"></p>
			</div>

			<Gridkaart :interaction="true" :predraw="false" :annotation="false" id="tool" />

			<div class="tekst">
				<p v-html="getContent(content.blokken[1].tekst2)"></p>
			</div>

			<Gridkaart :interaction="false" :predraw="true" :annotation="true" />

			<div class="tekst">
				<h2 v-html="getContent(content.blokken[1].tussenkop3)"></h2>
				
				<p v-html="getContent(content.blokken[1].tekst3)"></p>
			</div>

			<div class="knd-stepper">
				<img 
					:src="require('@/assets/img/strooi_nederland.svg')"
					class="strooi-nederland" />

				<div class="knd-stepper-tekst">
					<div 
						v-for="(step, index) in content.stepper" 
						:key="'step_' + index"
						class="knd-step">

						<div class="knd-step-img">
							<img :src="getImage(step.afbeelding[0].url)" />
						</div>
						<p class="knd-step-kop" v-html="getContent(step.kop)"></p>
						<p v-html="getContent(step.tekst)"></p>
					</div>
				</div>
			</div>
		</div>

		<div class="blok blok-4" id="quiz">
			<Landbouwquiz />
		</div>

		<div class="blok beeldblok">
			<video 
				autoplay
				playsinline 
				muted
				:src='require("@/assets/video/chaptervideos/chaptervideo_2.mp4#t=0.001")' 
				class="video">
				Uw browser ondersteunt het element <code>video</code> niet.
			</video>
		</div>

		<div class="blok overgang"></div>

		<div class="blok blok-5" id="carolien2">
			<div class="tekst">
				<h2 v-html="getContent(content.blokken[3].tussenkop1)"></h2>
				
				<p v-html="getContent(content.blokken[3].tekst1)"></p>

				<h2 v-html="getContent(content.blokken[3].tussenkop2)"></h2>

			</div>

			<div class="knd-video-wrapper">
				<video 
					playsinline 
					controls
					preload="metadata"
					class="video"
					:poster='require("@/assets/img/carolien_2.png")'>
					<source :src='require("@/assets/video/carolien_2.mp4#t=0.005")' type="video/mp4">
					Uw browser ondersteunt het element <code>video</code> niet.
				</video>
			</div>

			<!-- <div v-for="(content, index) in content.fotoalbum" :key='"album_" + index'>
				<Fotogrid :content="content" />
			</div> -->

			<div class="tekst">
				<h2 v-html="getContent(content.blokken[3].tussenkop3)"></h2>

				<p v-html="getContent(content.blokken[3].tekst3)"></p>
			</div>
		</div>

		<div class="blok beeldblok"> 
			<video 
				autoplay
				playsinline 
				muted
				:src='require("@/assets/video/chaptervideos/chaptervideo_3.mp4#t=0.005")' 
				class="video">
				Uw browser ondersteunt het element <code>video</code> niet.
			</video>
		</div>

		<div class="blok overgang"></div>

		<div class="blok blok-6" id="uitsmijter">
			<div class="tekst">
				<h2 v-html="getContent(content.blokken[4].tussenkop1)"></h2>
				
				<p v-html="getContent(content.blokken[4].tekst1)"></p>
			</div>

			<div 
				v-for="(link, index) in content.links"
				:key="'link' + index">
				
				<Teaser 
					:url="link.url" 
					:title="getContent(link.titel)" 
					:imgUrl="link.afbeelding[0].url" />
			</div>

			<div class="tekst">
				<p v-html="getContent(content.blokken[4].tekst2)"></p>
			</div>
		</div>

		<Colofon kleur="2A3700"/>
	</div>
</template>

<script>
import Percentage from './../components/percentage';
import Pijl from './../components/pijl';
import Gridkaart from './../components/gridkaart';
import Landbouwquiz from './../components/landbouwquiz';
// import Fotogrid from './../components/fotogrid';
import Colofon from './../components/colofon';
import Teaser from './../components/teaser';

import './story.scss'

export default {
	name: 'Story',
	data: function() {
		return {
			content: this.$store.state.content,
			windowWidth: 0
		}
	},
	mounted: function() {
		// console.log("story: ", this.content);

		this.windowWidth = window.innerWidth;
		window.addEventListener('resize', this.handleWindowResize);
	},
	methods: {
		getContent(content) {
			// if (this.$store.state.language === "nl") {
				return content.data;
			// }
			// else {
				// return content[label].data5891;	
			// }


		},

		goToId(name) {
			const tool = document.querySelector("#" + name);
			tool.scrollIntoView({behavior: "smooth", block: "start"});
		},

		handleWindowResize() {
			this.windowWidth = window.innerWidth;
		},

		getImage(url) {
			return 'https://pointer-dev.kro-ncrv.nl/' + url;
		}
	},
	components: {
		Percentage,
		Pijl,
		Gridkaart,
		Landbouwquiz,
		// Fotogrid,
		Colofon,
		Teaser
	}
}
</script>